import {
  Badge,
  Box,
  Button,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Popper,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import FilterListOffIcon from '@mui/icons-material/FilterListOff';
import ClearIcon from '@mui/icons-material/Clear';
import { CommonTexts } from 'locale/es';
import { useState } from 'react';
import { useFilter } from 'hooks/useFilter';
import { useFilterContext } from 'context/FilterContext';

const FilterTable = ({ tableHeaders, data }) => {
  const { handleFilterChange, handleSearchTerm, removeFilters, badgeCount } =
    useFilter(data, tableHeaders);

  const { selectedFilter, searchTerm } = useFilterContext();
  const [open, setOpen] = useState(false);

  const handleClickOpenPopper = (event) => {
    setOpen(open ? null : event.currentTarget);
  };

  const handleClose = () => {
    setOpen(!open);
  };

  const idPopper = open ? 'simple-popper' : undefined;
  const placement = 'bottom-start';

  return (
    <>
      <Button
        variant='outlined'
        type='button'
        sx={{
          width: { xs: 100, sm: 125 },
          mb: 2,
        }}
        onClick={handleClickOpenPopper}
        aria-describedby={idPopper}
      >
        <Badge
          badgeContent={badgeCount}
          color='primary'
          sx={{
            '& .MuiBadge-badge': {
              right: 12,
              top: 12,
              border: `1px solid`,
              padding: 0,
            },
          }}
        >
          <FilterListIcon sx={{ mr: 1 }} />
        </Badge>
        <Typography variant='button_text'>{CommonTexts.FILTER}</Typography>
      </Button>
      <Button
        variant='outlined'
        type='submit'
        sx={{
          width: { xs: 100, sm: 125 },
          mb: 2,
          ml: 2,
          color: 'red',
          borderColor: 'red',
        }}
        onClick={removeFilters}
      >
        <FilterListOffIcon sx={{ mr: 1 }} />
        <Typography variant='button_text'>
          {CommonTexts.DELETE_FILTERS}
        </Typography>
      </Button>
      <Popper
        id={idPopper}
        open={open}
        onClose={handleClose}
        anchorEl={open}
        placement={placement}
        sx={{
          bgcolor: 'background.paper',
          border: 1,
          borderColor: '#808080',
        }}
      >
        <IconButton
          aria-label='delete'
          onClick={handleClose}
          sx={{
            position: 'absolute',
            mt: '0.5 rem',
            mb: '1.5 rem',
            right: 40,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <ClearIcon sx={{ color: '#808080' }} />
        </IconButton>
        <IconButton
          aria-label='delete'
          onClick={handleClose}
          sx={{
            position: 'absolute',
            mt: '0.5 rem',
            mb: '1.5 rem',
            right: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <FilterListIcon sx={{ color: '#808080' }} />
        </IconButton>
        <Box sx={{ mt: '1.5rem' }}>
          <IconButton
            aria-label='delete'
            onClick={removeFilters}
            sx={{ my: 3 }}
          >
            <ClearIcon sx={{ color: '#808080' }} />
          </IconButton>
          <FormControl variant='outlined' sx={{ mt: 2, minWidth: 200 }}>
            <InputLabel
              id='select-selector-label'
              sx={{
                fontSize: '0.75rem',
              }}
            >
              {CommonTexts.FILTER_COLUMN}
            </InputLabel>
            <Select
              labelId='select-selector-label'
              id='label-selector'
              variant='outlined'
              value={selectedFilter}
              onChange={handleFilterChange}
              label={CommonTexts.FILTER_COLUMN}
              error={!selectedFilter && searchTerm}
              sx={{
                height: '3rem',
              }}
            >
              <MenuItem value=''>{CommonTexts.SELECT_FILTER}</MenuItem>
              {tableHeaders.map((header) => (
                <MenuItem key={header.value} value={header.value}>
                  {header.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            disabled={!selectedFilter}
            label={CommonTexts.FILTER_VALUE}
            variant='outlined'
            value={searchTerm}
            onChange={handleSearchTerm}
            sx={{
              m: 2,
              '& label': { fontSize: '0.75rem', marginBottom: 0 },
              '& .MuiInputBase-root': { height: '3rem' },
            }}
          />
        </Box>
      </Popper>
    </>
  );
};

export default FilterTable;
